import React from "react";
import Chez_papy from './../../assets/images/Chez_papy.png';

export default function Construction_page() {
  return (
    <div style={styles.container}>
      <img
        src={Chez_papy}
        alt="En construction"
        style={styles.image}
      />
    </div>
  );
}

const styles = {
  container: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#f5f5f5",
  },
  image: {
    maxWidth: "100%",
    height: "auto",
  },
};
